/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./airdrop.vue?vue&type=template&id=5c77b74c&scoped=true"
import script from "./airdrop.vue?vue&type=script&lang=js"
export * from "./airdrop.vue?vue&type=script&lang=js"
import style0 from "./airdrop.vue?vue&type=style&index=0&id=5c77b74c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c77b74c",
  null
  
)

export default component.exports